import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChartConfiguration } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss'],
  standalone: false
})
export class DoughnutChartComponent implements OnInit {

  @Input() chartLabels: string[] = [];
  @Input() data: any[] = [];
  @Input() colors: string[] = [];
  @Input() title: string = "";

  chartDatasets: ChartConfiguration<'doughnut'>['data']['datasets'] = [];

  public chartOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1,
    cutout: '55%',
    plugins: {
      tooltip: {
        enabled: false,
        external: (context) => {
          const tooltipModel = context.tooltip;
          let tooltipEl = document.getElementById('chartjs-tooltip');

          if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-tooltip';
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.background = '#000';
            tooltipEl.style.color = '#fff';
            tooltipEl.style.padding = '6px 10px';
            tooltipEl.style.borderRadius = '6px';
            tooltipEl.style.pointerEvents = 'none';
            tooltipEl.style.fontSize = '1.2rem';
            tooltipEl.style.fontWeight = '500';
            tooltipEl.style.textAlign = 'center';
            tooltipEl.style.zIndex = '9999';
            tooltipEl.style.transform = 'translate(-50%, -100%)';
            tooltipEl.style.whiteSpace = 'nowrap';

            document.body.appendChild(tooltipEl);
          }

          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = '0';
            return;
          }

          if (tooltipModel.dataPoints && tooltipModel.dataPoints.length) {
            const dataPoint = tooltipModel.dataPoints[0];
            const dataset = dataPoint.dataset;
            const color = (dataset.backgroundColor as string[])[dataPoint.dataIndex];
            const label = dataPoint.label;
            const value = dataPoint.formattedValue;

            tooltipEl.innerHTML = `
              <div style="position:relative;z-index:1;">
                <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px;">
                  <div style="width:10px;height:10px;border-radius:50%;background:${color}"></div>
                  <span>${label}</span>
                </div>
                <div style="font-weight:bold;font-size:1.2rem;">${value}</div>
              </div>
              <div style="
                position:absolute;
                left:50%;
                bottom:-6px;
                transform:translateX(-50%);
                width:0;
                height:0;
                border-left:6px solid transparent;
                border-right:6px solid transparent;
                border-top:6px solid #000;
              "></div>
            `;
          }

          const position = context.chart.canvas.getBoundingClientRect();
          tooltipEl.style.opacity = '1';
          tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
          tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY - 10 + 'px';
        }
      },
      datalabels: {
        display: false
      }
    },
    borderColor: '#fff',
  };
  
  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    this.plotGraph();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.plotGraph();
  } 

  plotGraph() {
    let values = this.data.map(function(v){
      return v.share;
    });

    this.chartLabels = this.data.map(v => {
      return this.translateService.instant(v.key);
    });

    this.chartDatasets = [
      { 
        data: values,
        backgroundColor: this.colors,
        borderWidth: 2,
        hoverBackgroundColor: this.colors 
      },
    ];
  }
}
